(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabs').forEach(tabs => {
      const nav = tabs.querySelector('.tabs__nav');
      const panels = tabs.querySelectorAll(':scope > .tabs__panels > .tab-panel');

      panels.forEach((panel, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tabs__btn';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-controls', panel.id);
        btn.textContent = panel.dataset.tabHeading || `Tab ${index + 1}`;

        if (index === 0) {
          btn.classList.add('tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');
          panel.removeAttribute('hidden');
        } else {
          btn.setAttribute('aria-selected', 'false');
        }

        btn.addEventListener('click', () => {
          tabs.querySelectorAll('.tabs__btn').forEach(b => {
            b.classList.remove('tabs__btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(p => p.setAttribute('hidden', ''));

          btn.classList.add('tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');
          panel.removeAttribute('hidden');
        });

        nav.appendChild(btn);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
